/**
 * The partner payout run — the shapes the run screen reads.
 *
 * `partner_ref` rather than `agent_ref` or `affiliate_ref`: the two API modules
 * are independent and always will be, but the row a screen renders is the same
 * row, and aliasing it once in each query is cheaper than a component that
 * carries two names for one column and picks between them on every cell.
 */
export interface PayoutRow {
  id: string;
  ref: string;
  amount: string;
  /** SCHEDULED · REQUESTED · PAID · REJECTED */
  status: string;
  is_early: boolean;
  handling_fee: string;
  created_at: string;
  paid_at: string | null;
  initiated_by: string;
  approved_by: string | null;
  approved_by_name: string | null;
  partner_id: string;
  partner_ref: string;
  partner_name: string;
  partner_status: string;
  payout_method: string | null;
  payout_account_mask: string | null;
  payout_hold_until: string | null;
  /** The result this payout was priced from. Null for an early request. */
  net_commission: string | null;
  held: boolean | null;
}

/** What a run WOULD raise, so the screen can say so before anyone commits. */
export interface PendingRun {
  payable: string;
  total: string;
  held: string;
  on_hold: string;
}

export interface PayoutRunPayload {
  period: {
    id: string;
    ref: string;
    status: string;
    periodStart: string;
    periodEnd: string;
  };
  payouts: PayoutRow[];
  pending: PendingRun;
  disbursement: string;
}

/** Which domain's run this is. The two never share a route or a table. */
export type PayoutDomain = 'agents' | 'affiliates';

export const PAYOUT_STATUS_LABEL: Record<string, string> = {
  SCHEDULED: 'Awaiting approval',
  REQUESTED: 'Early request',
  EARLY_REQUEST: 'Early request',
  PAID: 'Settled',
  REJECTED: 'Rejected',
};
